import { Pagination, PaginationItem } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ArrowLeft2, ArrowRight2 } from "iconsax-react";
import { memo } from "react";

import type { SefanoPaginationProps } from "./SefanoPagination.types";
import * as styles from "./SefanoPagination.styles";

export type { SefanoPaginationProps } from "./SefanoPagination.types";

export const SefanoPagination = memo(function SefanoPagination({
  count = 10,
  page = 1,
  ...paginationProps
}: SefanoPaginationProps) {
  const theme = useTheme();

  return (
    <Pagination
      count={count}
      page={page}
      sx={styles.root}
      renderItem={(item) => (
        <PaginationItem
          slots={{
            previous: () => (
              <ArrowRight2 size={18} variant="Linear" color={theme.palette.text.secondary} />
            ),
            next: () => (
              <ArrowLeft2 size={18} variant="Linear" color={theme.palette.text.secondary} />
            ),
          }}
          {...item}
        />
      )}
      {...paginationProps}
    />
  );
});
